var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0067FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12903 3.77419C4.12903 3.34662 4.47565 3 4.90323 3H11.0968C11.5243 3 11.871 3.34662 11.871 3.77419C11.871 4.20177 11.5243 4.54839 11.0968 4.54839H8.77419V12.0323C8.77419 12.4598 8.42758 12.8065 8 12.8065C7.57242 12.8065 7.22581 12.4598 7.22581 12.0323V4.54839H4.90323C4.47565 4.54839 4.12903 4.20177 4.12903 3.77419ZM3.38615 5.29127C3.68849 5.59361 3.68849 6.08381 3.38615 6.38615L1.86907 7.90323L3.38615 9.4203C3.68849 9.72265 3.68849 10.2128 3.38615 10.5152C3.08381 10.8175 2.59361 10.8175 2.29127 10.5152L0.226756 8.45066C-0.0755853 8.14832 -0.0755853 7.65813 0.226756 7.35579L2.29127 5.29127C2.59361 4.98893 3.08381 4.98893 3.38615 5.29127ZM12.6139 5.29127C12.9162 4.98893 13.4064 4.98893 13.7087 5.29127L15.7732 7.35579C16.0756 7.65813 16.0756 8.14832 15.7732 8.45066L13.7087 10.5152C13.4064 10.8175 12.9162 10.8175 12.6139 10.5152C12.3115 10.2128 12.3115 9.72265 12.6139 9.4203L14.1309 7.90323L12.6139 6.38615C12.3115 6.08381 12.3115 5.59361 12.6139 5.29127Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon-text.f2dfec076c91242985bc5273f974454c.svg";
export { ForwardRef as ReactComponent };